import React from 'react';
import { Flex, TextField } from '@knockrentals/knock-shared-web-v2';
import { DividedTabSection } from '../../TabSections';
import { SECTIONS } from '../../constants';
import { contactInfoPropTypes } from '../../../../prop-types';
import { CONTACT_TEXT_FIELDS, FIELD_LABELS } from './constants';

const { DESCRIPTION, TITLE } = SECTIONS.CONTACT_INFO;

const ContactInfo = ({ contactInfo = {} }) => (
  <DividedTabSection description={DESCRIPTION} title={TITLE}>
    <Flex gap={16}>
      {CONTACT_TEXT_FIELDS.map((field) => (
        <TextField
          key={field}
          disabled
          endIcon="lock"
          fullWidth
          id={field}
          label={FIELD_LABELS[field]}
          name={field}
          value={contactInfo[field]}
          variant="outlined"
        />
      ))}
    </Flex>
  </DividedTabSection>
);

ContactInfo.propTypes = {
  contactInfo: contactInfoPropTypes,
};

export default ContactInfo;
